import React, { useEffect, useState } from 'react';

type Props = {
    ClosePopup: Function;
    document: any;
};

const SigningPopUpDocument = (props: Props) => {

    const [url, setUrl] = useState<string>('');
    // dragg and drop
    const [isDragging, setIsDragging] = useState<boolean>(false);
    const [position, setPosition] = useState<any>({ x: 800, y: 20 })
    const [offset, setOffset] = useState<any>({ x: 0, y: 0 })

    const closePopup = (status?: string) => {
        if (props.ClosePopup) {
            props.ClosePopup(status);
        }
    }
    useEffect(() => {
        console.log('ClientDocumentPopup', props.document.filePath)
        const apiLocalStorage = localStorage.getItem('apiUrl');
        if (apiLocalStorage) {
            const fullUrl = `${apiLocalStorage}/${props.document.filePath}`;
            setUrl(fullUrl);
        }
    }, [])

    const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        console.log('handleMouseDown', e.clientX, e.clientY);
        setIsDragging(true);
        setOffset({
            x: e.clientX - position.x,
            y: e.clientY - position.y
        })
    }

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        console.log('handleMouseMove');
        if (isDragging) {
            setPosition({ x: e.clientX - offset.x, y: e.clientY - offset.y })
        }
    }

    const handleMouseUp = (): void => {
        console.log('handleMouseUp');
        setIsDragging(false);
    };


    return (
        <div>
            <section className="popup-window new-lead rtl" style={{ position: 'absolute', top: position.y, left: position.x, zIndex: 1000 , boxShadow: '0px -3px 15px #052F5D5C'}}>
                <div className="close-icon pointer" onClick={() => closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title" style={{ cursor: isDragging ? 'grabbing' : 'grab', }}
                            onMouseDown={handleMouseDown}
                            onMouseMove={handleMouseMove}
                            onMouseUp={handleMouseUp}
                            onMouseLeave={handleMouseUp}>
                            {url}
                        </div>
                    </div>
                    <div className="popup-body">
                        {url && url.length > 0 && (url.includes('.pdf') || url.includes('.PDF') || url.includes('.png') || url.includes('.jpg')
                            || url.includes('.jpeg') || url.includes('.JPG') || url.includes('.PNG') || url.includes('.JPEG')) ?
                            <iframe src={url} style={{ width: '100%', height: '750px',border: 'none',pointerEvents: 'all' }} />
                            : <iframe src={viewerUrl} style={{ width: '100%', height: '750px',border: 'none',pointerEvents: 'all'  }} />
                        }
                        {/* <iframe src={viewerUrl} style={{ width: '100%', height: '700px' }} /> */}
                        {/* <iframe src={`https://docs.google.com/gview?url=${encodeURIComponent(props.document.filePath)}&embedded=true`} style={{width:'100%',height:'700px'}}></iframe> */}

                    </div>
                    <div className="popup-footer">
                        <button className="button white blue-border" onClick={(e: any) => closePopup()}>
                            סגור
                        </button>
                    </div>
                </div>
            </section>
        </div>

    )
}
export default SigningPopUpDocument;

{/* <iframe src={props.document.filePath} style={{width:'100%',height:'700px'}}></iframe> */ }